import { Action, From, Message } from './vitrual-assistant.type';

export const createMessage = (from: From, text: string, action?: Action): Omit<Message, 'id'> => {
    return { from, text, action };
};

export const fromUser = (text: string) => createMessage(From.USER, text);

export const fromAssistant = (text: string, action?: Action) =>
    createMessage(From.ASSISTANT, text, action);

export const delay = async (delay: number) => new Promise((res) => setTimeout(res, delay));
